import { BASE_URL } from "../../../api/config";

export const Login = async (
  email: string,
  password: string,
): Promise<Response> => {
  try {
    const res = await fetch(BASE_URL + "auth/login", {
      method: "POST",
      body: JSON.stringify({
        email: email,
        password: password,
      }),
      headers: {
        "Content-type": "application/json",
      },
    });

    if (!res.ok) {
      const errorData = await res.json();
      console.error("Errore API lato server:", errorData);
      return new Response(JSON.stringify(errorData), {
        status: res.status,
        headers: { "Content-Type": "application/json" },
      });
    }
    return res;
  } catch (error) {
    console.error("Errore di rete:", error);
    return new Response(
      JSON.stringify({
        success: false,
        message: "Errore di rete o server non raggiungibile",
      }),
      {
        status: 500,
        headers: { "Content-Type": "application/json" },
      },
    );
  }
};
